'use client';

import ReactDOM from 'react-dom';

export function PreloadResources() {
  const directusUrl =
    process.env.NEXT_PUBLIC_DIRECTUS_API_URL || 'https://proxy.kiaretail.co.za';

  const directusNcUrl =
    process.env.NEXT_PUBLIC_DIRECTUS_NC_API_URL;

  const origins = new Set(
    [directusUrl, directusNcUrl]
      .filter((url): url is string => Boolean(url))
      .map((url) => new URL(url).origin),
  );

  origins.forEach((origin) => {
    ReactDOM.preconnect(origin);
  });

  return null;
}
